import Consts from "Interfaces/Consts";
import { FormFieldProps, FormTypeComponentProps as Props } from './ContactUs.Interfaces';
import FormField from './ContactUs_FormField';

const ContactUsFullWidthForm: React.FC<Props> = ({
    variableInputs,
    hideName,
    hidePhone,
    componentId,
    inputValues,
    changeInput,
    validateInput,
    errors,
    isVariable1Req,
    isVariable2Req
}) => {

    const classForVariableInput = (variableInputs[0] && variableInputs[1]) ? " two-inp" : " one-inp";
    const classForInput = (!hideName && !hidePhone) ? " two-inp" : " one-inp";

    // Returns all the input's needed attributes and props
    const getFormFieldProps = (
        keyName: string,
        name: string,
        inputType: 'tel' | 'text' | 'email' | 'textarea',
        isRequired = true,
        classForInput = '',
    ): FormFieldProps => {

        const wrapperClass = ` px-sm-0 ${classForInput}`;

        return {
            label: Consts[keyName],
            inputValue: inputValues[keyName],
            labelIcon: ICONS[keyName] || '',
            error: errors[keyName],
            onChange: (event) => changeInput(event, keyName),
            onBlur: (event) => validateInput(event, keyName),
            name,
            componentId,
            inputType,
            isRequired,
            classForInput: wrapperClass,
        }
    }

    const ICONS = {
        email: 'icon-MSite--175',
        phone: 'icon-MSite--218',
        name: 'icon-MSite--203',
        message: 'icon-MSite--150',
        variable1: 'icon-MSite--146',
        variable2: 'icon-MSite--146',
    }

    const hasVariable1 = variableInputs.length > 0 && !!variableInputs[0];
    const hasVariable2 = variableInputs.length > 1 && !!variableInputs[1];

    const nameInputProps = getFormFieldProps('name', 'Name', 'text', true, classForInput);
    const phoneInputProps = getFormFieldProps('phone', 'Phone', 'tel', true, classForInput);
    const emailInputProps = getFormFieldProps('email', 'Email', 'email', true);
    const messageInputProps = getFormFieldProps('message', 'Message', 'textarea', true, 'col-md-12');
    const variable1InputProps = hasVariable1 ? getFormFieldProps('variable1', 'Variable1', 'text', isVariable1Req, classForVariableInput) : null;
    const variable2InputProps = hasVariable2 ? getFormFieldProps('variable2', 'Variable2', 'text', isVariable2Req, classForVariableInput) : null;

    return (
        <>

            {
                (!hideName || !hidePhone) &&

                <div className="form-row-unbootstrap">

                        {!hideName && <InputField {...nameInputProps} /> }

                        {!hidePhone && <InputField {...phoneInputProps} /> }

                </div>
            }

            <InputField {...emailInputProps} />

            {
                (hasVariable1 || hasVariable2) &&

                <div className="one-line">
                    {
                        hasVariable1 &&
                        <InputField {...variable1InputProps}  isVariable={true} label={variableInputs[0]} />
                    }
                    {
                        hasVariable2 &&
                        <InputField {...variable2InputProps} isVariable={true} label={variableInputs[1]} />
                    }
                </div>
            }

            <InputField {...messageInputProps} />

            <div className="mzFormGroup">
                <div className='requiredMessage'>{Consts.requiredMessage}</div>
            </div>
        </>
    )
}

const InputField = (props: FormFieldProps) => {
    return <FormField {...props}>

        <FormField.Error />

        {
            props.inputType == 'textarea' ?
                <FormField.TextArea /> :
                <FormField.Input />
        }

        <FormField.Label className={props.labelIcon } />

    </FormField>
}
export default ContactUsFullWidthForm;